exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "[data-v-5296f767] .template-page {\n  border: 2px dotted black;\n  background-color: whitesmoke;\n  margin-bottom: 12px;\n  padding: 20px;\n  padding-bottom: 0px;\n}\n[data-v-5296f767] .template-page.selected-page {\n    border: 2px dashed gray;\n}\n", ""]);

